/* eslint-disable array-callback-return */
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import './App.scss';
import Swal from 'sweetalert2';
import Cookies from 'js-cookie';
import NavigationMenu from './SharedModules/Navigation/navigationMenu';
import Login from './Login';
import Spinner from './SharedModules/Spinner/Spinner';
import { generateUUID } from './SharedModules/DateUtilities/DateUtilities';
import {
  setUserprivileges,
  setLogInUserID,
  getUserInquiryPrivilege,
  loginUserData,
  getKeycloakObj,
  checkUserActivity,
  storeUserAuthorizedRoutes,
  setLogInUserInRedux,
  setLoginStateStore,
} from './SharedModules/store/Actions/SharedAction';
import { helpObj } from './SharedModules/Navigation/navStructure';
import { dispatchUserRole } from './Modules/Maintain/Check/store/actions';

function Confirm({ setConfirm, confirmCallback, setUUID }) {
  Swal.fire({
    customClass: {
      confirmButton: 'btn-text1 btn-transparent mr-3',
      cancelButton: 'btn1 btn-success',
      container: 'unsaved-changes-popup',
    },
    allowOutsideClick: false,
    buttonsStyling: false,
    heightAuto: false,
    icon: 'warning',
    html: '<h4>Unsaved changes will be lost.<br/>Are you sure you want to Exit?</h4 >',
    showCancelButton: true,
    confirmButtonText: 'Stay on this page!',
    cancelButtonText: 'Continue! <i class="fa fa-arrow-right ml-1"></i>',
  }).then((result) => {
    if (result.value) {
      blockTransition();
    } else {
      allowTransition();
    }
  });
  function allowTransition() {
    setConfirm(false);
    confirmCallback(true);
    setUUID(generateUUID());
  }

  function blockTransition() {
    setConfirm(false);
    confirmCallback(false);
  }

  return <React.Fragment />;
}

function App() {
  const dispatch = useDispatch();
  const [spinnerLoader, setSpinnerLoader] = useState(false);
  const [confirm, setConfirm] = useState(false);
  const [login, setLogin] = useState(false);
  const [logInUser, setLogInUser] = useState(null);
  const [uuid, setUUID] = useState(generateUUID);
  /* const [userPrivilegesList, setUserPrivilegesList] = useState([]);
  const [userDoesntExist, setUserDoesntExist] = useState(false);
  const [loginErrorMessages, setLoginErrorMessages] = useState([]);
  const [prompt, setPrompt] = useState(false);
  const [userRoles, setUserRoles] = useState([]);
  const [userFullName, setUserFullName] = useState(''); */

  /*   const userPrivileges = useSelector(
    (state) => state.sharedState.userPrivileges
  ); */

  const keycloakValue = useSelector(
    (state) => state?.sharedState?.SharedReducer?.keycloakObj
  );

  const loginStateStoreObj = useSelector(
    (state) => state?.sharedState?.SharedReducer?.loginStateStoreObj
  );

  const [showSideMenu, setShowSideMenu] = useState({
    applicationConfig: false,
    bankAccount: false,
    fiscalPend: false,
    budgetMaintenance: false,
    accountReceivable: false,
    financialEntity: false,
    fiscalPayout: false,
    financialReceipt: false,
    fundCode: false,
    Correction1099: false,
    FinancialInquiry: false,
    FssAdminUser: false,
    FinancialTXN: false,
  });

  const [userInquiry, setUserInquiry] = useState({
    applicationUser: false,
    applicationInquiry: false,
    bankAccUser: false,
    bankAccInquiry: false,
  });

  /* const setUserPrivilaagesOnRoles = (userPrivilegesLists) => {
    let applicationConfig = false;
    let bankAccount = false;
    let fiscalPend = false;
    let budgetMaintenance = false;
    let accountReceivable = false;
    let financialEntity = false;
    let fiscalPayout = false;
    let financialReceipt = false;
    let fundCode = false;
    let Correction1099 = false;
    let FinancialInquiry = false;
    let fssAdminUser = false;
    let finUploadUser = false;
    let applicaionUser = false;
    let applicationInquiry = false;
    let bankUser = false;
    let bankInquiry = false;
    let fiscalPendUser = false;
    let budgetMainUser = false;
    let fundCodeUser = false;
    let aRMainUser = false;
    let financialEntityUser = false;
    let payOutMainUser = false;
    let payOutManger = false;
    let payoutManagerorMainUser = false;
    let receiptMainUser = false;
    let mainUser1099 = false;
    let mainManager1099 = false;
    let managerOrMainUser1099 = false;
    let finUploadMainUser = false;
    if (userPrivilegesLists && userPrivilegesLists.length > 0) {
      userPrivilegesLists.map((value) => {
        if (
          value === 'ApplicationConfigurationUser' ||
          value === 'ApplicationConfigurationInquiry'
        ) {
          applicationConfig = true;
          if (value === 'ApplicationConfigurationUser') {
            applicaionUser = true;
          }
          if (value === 'ApplicationConfigurationInquiry') {
            applicationInquiry = true;
          }
        }
        if (
          value === 'BankAccountMaintenanceUser' ||
          value === 'BankAccountMaintenanceInquiry'
        ) {
          bankAccount = true;
          if (value === 'BankAccountMaintenanceUser') {
            bankUser = true;
          }
          if (value === 'BankAccountMaintenanceInquiry') {
            bankInquiry = true;
          }
        }
        if (
          value === 'FiscalPendConfigurationUser' ||
          value === 'FiscalPendConfigurationInquiry'
        ) {
          fiscalPend = true;
          if (value === 'FiscalPendConfigurationUser') {
            fiscalPendUser = true;
          }
        }
        if (
          value === 'BudgetMaintenanceUser' ||
          value === 'BudgetMaintenanceInquiry'
        ) {
          budgetMaintenance = true;
          fundCode = true;
          if (value === 'BudgetMaintenanceUser') {
            budgetMainUser = true;
            fundCodeUser = true;
          }
        }
        if (value === 'FinancialUploadUser') {
          finUploadUser = true;
          finUploadMainUser = true;
        }
        if (value === 'ARMaintenanceUser' || value === 'ARMaintenanceInquiry') {
          accountReceivable = true;
          if (value === 'ARMaintenanceUser') {
            aRMainUser = true;
          }
        }
        if (
          value === 'FinancialEntityUser' ||
          value === 'FinancialEntityInquiry'
        ) {
          financialEntity = true;
          if (value === 'FinancialEntityUser') {
            financialEntityUser = true;
          }
        }
        if (
          value === 'PayoutMaintenanceUser' ||
          value === 'PayoutMaintenanceManager' ||
          value === 'PayoutMaintenanceInquiry'
        ) {
          fiscalPayout = true;
          if (value === 'PayoutMaintenanceUser') {
            payOutMainUser = true;
          }
          if (value === 'PayoutMaintenanceManager') {
            payOutManger = true;
          }
          if (
            value === 'PayoutMaintenanceManager' ||
            value === 'PayoutMaintenanceUser'
          ) {
            payoutManagerorMainUser = true;
          }
        }
        if (
          value === 'ReceiptMaintenanceUser' ||
          value === 'ReceiptMaintenanceInquiry'
        ) {
          financialReceipt = true;
          if (value === 'ReceiptMaintenanceUser') {
            receiptMainUser = true;
          }
        }
        if (
          value === '1099MaintenanceUser' ||
          value === '1099MaintenanceManager' ||
          value === '1099MaintenanceInquiry'
        ) {
          Correction1099 = true;
          if (value === '1099MaintenanceUser') {
            mainUser1099 = true;
          }
          if (value === '1099MaintenanceManager') {
            mainManager1099 = true;
          }
          if (
            value === '1099MaintenanceManager' ||
            value === '1099MaintenanceUser'
          ) {
            managerOrMainUser1099 = true;
          }
        }
        if (value === 'FinancialInquiryUser') {
          FinancialInquiry = true;
        }
        if (value === 'FSSAdministrator') {
          fssAdminUser = true;
        }
      });
    }
    setShowSideMenu({
      applicationConfig: applicationConfig,
      bankAccount: bankAccount,
      fiscalPend: fiscalPend,
      budgetMaintenance: budgetMaintenance,
      accountReceivable: accountReceivable,
      financialEntity: financialEntity,
      fiscalPayout: fiscalPayout,
      financialReceipt: financialReceipt,
      fundCode: fundCode,
      Correction1099: Correction1099,
      FinancialInquiry: FinancialInquiry,
      FssAdminUser: fssAdminUser,
      FinanceUploadUser: finUploadUser,
      FinancialTXN: true,
    });
    setUserInquiry({
      applicationUser: applicaionUser,
      applicationInquiry: applicationInquiry,
      bankAccUser: bankUser,
      bankAccInquiry: bankInquiry,
      fiscalPendUser: fiscalPendUser,
      budgetMainUser: budgetMainUser,
      fundCodeUSer: fundCodeUser,
      aRMainUser: aRMainUser,
      financialEntityUSer: financialEntityUser,
      payOutMainUser: payOutMainUser,
      payOutManager: payOutManger,
      payoutManagerorMainUser: payoutManagerorMainUser,
      receiptMainUser: receiptMainUser,
      mainUser1099: mainUser1099,
      mainManager1099: mainManager1099,
      managerOrMainUser1099: managerOrMainUser1099,
      FssAdminUser: fssAdminUser,
      financeUploadMainUser: finUploadMainUser,
    });
    dispatch(
      getUserInquiryPrivilege({
        applicationUser: applicaionUser,
        applicationInquiry: applicationInquiry,
        bankAccUser: bankUser,
        bankAccInquiry: bankInquiry,
        fiscalPendUser: fiscalPendUser,
        budgetMainUser: budgetMainUser,
        financeUploadMainUser: finUploadMainUser,
        fundCodeUSer: fundCodeUser,
        aRMainUser: aRMainUser,
        financialEntityUSer: financialEntityUser,
        payOutMainUser: payOutMainUser,
        payOutManager: payOutManger,
        payoutManagerorMainUser: payoutManagerorMainUser,
        receiptMainUser: receiptMainUser,
        mainUser1099: mainUser1099,
        mainManager1099: mainManager1099,
        managerOrMainUser1099: managerOrMainUser1099,
        FssAdminUser: fssAdminUser,
      })
    );
  }; */

  const userData = useSelector(
    (state) => state?.sharedState?.SharedReducer?.loginUserData
  );

  // const getUser = (value) => dispatch(loginUserData(value));

  const safeLocalStorage = (actType, storeName, data) => {
    let res;
    try {
      if (actType === 'set') {
        res = localStorage.setItem(storeName, data);
      } else if (actType === 'get') {
        res = localStorage.getItem(storeName);
      } else if (actType === 'remove') {
        res = localStorage.removeItem(storeName);
      }
    } catch {
      console.error('No access to local storage.');
    }
    return res;
  };

  // useEffect(() => {
  //   if (userData) {
  //     const { data } = userData;
  //     data.push(helpObj);
  //     // let data = parseJwt(userData.data);
  //     safeLocalStorage('set', 'loginState', JSON.stringify({
  //       logInUser: logInUser?.trim(),
  //       loginUserName: logInUser?.toUpperCase(),
  //       userPrivileges: userRoles,
  //       menuItems: data,
  //       // userName: userFullName,
  //       time: Date.now(),
  //       readOnly: data && data[0]?.readOnly
  //     }));
  //     // localStorage.setItem('ssoToken', userData.ssoToken);
  //     // localStorage.setItem('expiresInSeconds', userData.expiresInSeconds);
  //     // localStorage.setItem('refreshToken', userData.refreshToken);
  //     // localStorage.setItem('accessToken', userData.accessToken);
  //     // if (!lssoUSer) {
  //     //   document.cookie =
  //     //     `${'iPlanetDirectoryPro' +
  //     //     '='}${userData.ssoToken
  //     //     };` +
  //     //     `;domain=.${window.location.host};path=/;secure;`;
  //     // }
  //     dispatch(setLogInUserID(logInUser?.trim()));
  //     // dispatch(setTokenInStore(userData));
  //     // const rolesData = data.roles?.split(',');
  //     // const rolesNavData = [];
  //     // if (rolesNavData.length) {
  //     //   dispatch(setNavigationPrivileges(rolesNavData));
  //     // }
  //     setLogin(true);
  //   } else if (safeLocalStorage('get', 'loginState')) {
  //     setSpinnerLoader(false)
  //     setLogin(true);
  //   } else if (userData && userData.errorType === 'invalid_grant') {
  //     setLoginErrorMessages({ userNameInvalidErr: true });
  //     setSpinnerLoader(false)
  //     setLogin(false);
  //   } else {
  //     setLogin(false);
  //   }
  //   setSpinnerLoader(false);
  // }, [userData]);

  // useEffect(() => {
  //   const loginSeasonLength = 12 * 60 * 60 * 1000;
  //   let storedSession = safeLocalStorage('get', 'loginState');
  //   storedSession = storedSession && JSON.parse(storedSession);
  //   let userPrivilegesListToSet = [];
  //   if (userPrivileges && userPrivileges.respcode === '01') {
  //     setLoginErrorMessages([]);
  //     userPrivilegesListToSet =
  //       userPrivileges.enterpriseSearchresultVO.searchResults;
  //   }
  //   if (
  //     userPrivileges &&
  //     userPrivileges.respcode === '01' &&
  //     userPrivilegesListToSet &&
  //     userPrivilegesListToSet.length > 0
  //   ) {
  //     safeLocalStorage(
  //       'set',
  //       'loginState',
  //       JSON.stringify({ logInUser, userPrivilegesListToSet, time: Date.now() })
  //     );
  //     setUserPrivilegesList(userPrivilegesListToSet);
  //     setUserprivileges(userPrivilegesListToSet);
  //     setUserPrivilaagesOnRoles(userPrivilegesListToSet);
  //     setLogin(true);
  //     dispatch(setLogInUserID(logInUser));
  //     setUserDoesntExist(false);
  //   } else if (storedSession) {
  //     if (Date.now() - storedSession.time < loginSeasonLength) {
  //       setUserPrivilegesList(storedSession.userPrivilegesListToSet);
  //       setUserPrivilaagesOnRoles(storedSession.userPrivilegesListToSet);
  //       setUserprivileges(storedSession.userPrivilegesListToSet);
  //       setLogin(true);
  //       dispatch(setLogInUserID(storedSession.logInUser));
  //       setUserDoesntExist(false);
  //     } else {
  //       // setLogin(false);
  //       safeLocalStorage('remove', 'loginState');
  //       setUserDoesntExist(false);
  //     }
  //   }
  //   if (
  //     userPrivileges &&
  //     userPrivileges.respcode === '02' &&
  //     userPrivilegesListToSet &&
  //     userPrivilegesListToSet.length === 0
  //   ) {
  //     setUserDoesntExist(true);
  //     let tempErrorMessageAArray = [];
  //     tempErrorMessageAArray = userPrivileges.errorMessages;
  //     setLoginErrorMessages(tempErrorMessageAArray);
  //   }

  //   // Login with DB Credentials
  //   // if (userPrivileges && userPrivileges.uid) {
  //   //   const loginId = userPrivileges.uid
  //   //   safeLocalStorage(
  //   //     "set",
  //   //     "loginState",
  //   //     JSON.stringify({ loginId, userPrivilegesListToSet, time: Date.now() })
  //   //   );
  //   //   setUserPrivilegesList(userPrivilegesListToSet);
  //   //   setUserprivileges(userPrivilegesListToSet);
  //   //   setUserPrivilaagesOnRoles(userPrivilegesListToSet);
  //   //   setLogin(true);
  //   //   dispatch(setLogInUserID(loginId));
  //   //   setUserDoesntExist(false);
  //   // }
  //   // DB Values Starts
  //   if (userPrivileges && userPrivileges.length > 0) {
  //     safeLocalStorage(
  //       'set',
  //       'loginState',
  //       JSON.stringify({ logInUser, userPrivileges, time: Date.now() })
  //     );
  //     setUserPrivilegesList(userPrivileges);
  //     setUserprivileges(userPrivileges);
  //     setUserPrivilaagesOnRoles(userPrivileges);
  //     setLogin(true);
  //     dispatch(setLogInUserID(logInUser));
  //     setUserDoesntExist(false);
  //   } else if (storedSession) {
  //     if (Date.now() - storedSession.time < loginSeasonLength) {
  //       setUserPrivilegesList(
  //         storedSession.userPrivileges
  //           ? storedSession.userPrivileges
  //           : storedSession.userPrivilegesListToSet
  //       );
  //       setUserPrivilaagesOnRoles(
  //         storedSession.userPrivileges
  //           ? storedSession.userPrivileges
  //           : storedSession.userPrivilegesListToSet
  //       );
  //       setUserprivileges(
  //         storedSession.userPrivileges
  //           ? storedSession.userPrivileges
  //           : storedSession.userPrivilegesListToSet
  //       );
  //       setLogin(true);
  //       dispatch(
  //         setLogInUserID(
  //           storedSession.logInUser
  //             ? storedSession.logInUser
  //             : storedSession.loginId
  //         )
  //       );
  //       setUserDoesntExist(false);
  //     } else {
  //       // setLogin(false);
  //       safeLocalStorage('remove', 'loginState');
  //       setUserDoesntExist(false);
  //     }
  //   }
  //   if (userPrivileges && userPrivileges.length === 0) {
  //     setUserDoesntExist(true);
  //   }
  //   // DB Values Ends
  //   setSpinnerLoader(false);
  // }, [userPrivileges]);

  // function to filter and store the matching objects
  const filterRoutesByRoles = (accessibleRoutes, roles) => {
    const filteredRoutes = new Set();
    roles.forEach((role) => {
      const matchingRoute = accessibleRoutes.find(
        (route) => route.role === role
      );
      if (matchingRoute) {
        matchingRoute.urlList.forEach((route) => filteredRoutes.add(route));
      }
    });
    return Array.from(filteredRoutes);
  };

  const storeNavigationMenusData = (response, roles, userName) => {
    if (response) {
      const filteredRoutes = filterRoutesByRoles(
        response?.accessibleRouteList,
        roles
      );
      // console.log(filteredRoutes,response?.accessibleRouteList, response)
      dispatch(storeUserAuthorizedRoutes(filteredRoutes));
      const { data } = response;
      // data.push(helpObj);
      // let data = parseJwt(userData.data);
      // safeLocalStorage(
      //   'set',
      //   'loginState',
      //   JSON.stringify({
      //     logInUser: userName?.trim(),
      //     loginUserName: userName?.toUpperCase(),
      //     userPrivileges: roles,
      //     accessibleRoutes: filteredRoutes,
      //     menuItems: data,
      //     userName: userName,
      //     time: Date.now(),
      //     readOnly: data && data[0]?.readOnly,
      //   })
      // );
      let loginStateStore = {
        logInUser: userName?.trim(),
        loginUserName: userName?.toUpperCase(),
        userPrivileges: roles,
        accessibleRoutes: filteredRoutes,
        menuItems: data,
        userName: userName,
        time: Date.now(),
        readOnly: data && data[0]?.readOnly,
      };
      dispatch(setLoginStateStore(loginStateStore));
      dispatch(setLogInUserID(logInUser?.trim()));
      setLogin(true);
    } else if (loginStateStoreObj) {
      setSpinnerLoader(false);
      setLogin(true);
    } else if (userData && userData.errorType === 'invalid_grant') {
      /* setLoginErrorMessages({ userNameInvalidErr: true }); */
      setSpinnerLoader(false);
      setLogin(false);
    } else {
      setLogin(false);
    }
    setSpinnerLoader(false);
  };
  // console.log(keycloakValue,loginStateStoreObj,userData)
  const callGetUserDetailsAPI = (roles, userName) => {
    dispatch(dispatchUserRole(roles));
    const payload = {
      userRoles: roles,
    };
    console.log("app js payload",payload);
    // console.log(roles, userName)
    loginUserData(payload).then((response) => {
      storeNavigationMenusData(response, roles, userName);
    });
    setSpinnerLoader(true);
  };

  const setLoginDone = (keycloakObj) => {
    dispatch(getKeycloakObj(keycloakObj));
    const parsedToken = keycloakObj?.tokenParsed;
    const accessToken = keycloakObj?.token;
    const refreshToken = keycloakObj?.refreshToken;
    const expiresInSeconds = keycloakObj?.messageReceiveTimeout;
    const clientId = keycloakObj?.clientId;
    let userName = '';
    if (parsedToken) {
      userName = parsedToken.preferred_username;
      // const email = parsedToken.email;
      const givenName = parsedToken.given_name;
      const familyName = parsedToken.family_name;
      const fullName = `${givenName} ${familyName}`;
      const resourceObj = parsedToken.resource_access;
      if (resourceObj) {
        const userRolesObj = Object.keys(resourceObj)
          .filter((key) => key === clientId)
          .reduce((obj, key) => {
            return Object.assign(obj, { [key]: resourceObj[key] });
          }, {});
        if (userRolesObj) {
          const userRolesArray = userRolesObj[clientId]?.roles;
          /* setUserRoles(userRolesArray); */
          callGetUserDetailsAPI(userRolesArray, userName);
        }
      }
      /* setUserFullName(fullName); */
      setLogin(true);
    }
    setLogInUser(userName);
    // safeLocalStorage('set', 'logInUser', userName);
    dispatch(setLogInUserInRedux(userName));
    safeLocalStorage('set', 'expiresInSeconds', expiresInSeconds);
    safeLocalStorage('set', 'refreshToken', refreshToken);
    safeLocalStorage('set', 'accessToken', accessToken);
  };
  const setLoginDoneSAML = (userProfile) => {
    const userName = userProfile.uid;
    const userRoles = userProfile.roles;
    dispatch(getKeycloakObj(userProfile));
    callGetUserDetailsAPI(userRoles, userName);
    setLogin(true);
    setLogInUser(userName);
    dispatch(setLogInUserInRedux(userName));
    safeLocalStorage('set', 'uid', userName);
    safeLocalStorage('set', 'roles', JSON.stringify(userRoles));
  }

  // useEffect(() => {
  //   if (login) {
  //     dispatch(checkUserActivity());
  //   }
  // }, [login]);

  // Logout for multiple tabs open

  useEffect(() => {
    window.addEventListener('storage', () => {
      if (!loginStateStoreObj) {
        setLogin(false);
        /* setUserDoesntExist(false); */
        setUserprivileges([]);
        setLogInUserID(null);
      }
    });
  });

  const setLogOut = () => {
    setLogin(false);
    setUserprivileges([]);
    setLogInUserID(null);
    // safeLocalStorage('remove', 'logInUser');
    dispatch(setLogInUserInRedux(null));
    Cookies.remove('userProfile');
    // safeLocalStorage('remove', 'loginState');
    dispatch(setLoginStateStore([]));
    keycloakValue.logout();
  };

  const [confirmCallback, setConfirmCallback] = useState(null);

  function getConfirmation(message, callback) {
    setConfirmCallback(() => callback);
    setConfirm(true);
  }

  // const handleOnActive = (event) => {
  //   if (login && getRemainingTime() === 0) {
  //     setLogOut();
  //   }
  // };

  // const { getRemainingTime } = useIdleTimer({
  //   timeout: REACT_APP_IDLE_TIME,
  //   onActive: handleOnActive,
  // });

  return (
    <Router getUserConfirmation={getConfirmation}>
      {spinnerLoader ? <Spinner /> : null}
      {!login ? (
        <Login setLoginDone={setLoginDone} setLoginDoneSAML={setLoginDoneSAML} />
      ) : (
        <NavigationMenu
          showSideMenu={showSideMenu}
          userInquiry={userInquiry}
          uuid={uuid}
          setLogOut={setLogOut}
        />
      )}
      {confirm && (
        <Confirm
          confirmCallback={confirmCallback}
          setConfirm={setConfirm}
          setUUID={setUUID}
        />
      )}
    </Router>
  );
}

export default App;
